import {
  Archive,
  ArrowLeft,
  ArrowRight,
  Cake,
  Calendar,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsUpDown,
  CircleArrowDown,
  CircleArrowUp,
  CircleCheck,
  CircleDot,
  CircleUser,
  Clock,
  Copy,
  EllipsisVertical,
  Eye,
  FilePen,
  Filter,
  Forward,
  Frown,
  Globe,
  Info,
  Lamp,
  Lightbulb,
  List,
  ListChecks,
  ListPlus,
  Lock,
  MapPin,
  Meh,
  Menu,
  MessageCircle,
  MessageSquare,
  Mic,
  MicOff,
  Pause,
  Phone,
  PhoneCall,
  PhoneOff,
  PhoneOutgoing,
  Play,
  Plus,
  Power,
  RefreshCw,
  Search,
  Smile,
  SquarePen,
  Trash2,
  TriangleAlert,
  Type,
  Undo2,
  Unplug,
  User,
  UserPlus,
  UserRound,
  Voicemail,
  Wrench,
  X,
} from 'lucide-react';
import { LucideIcon } from 'lucide-react';

export const ICONS: Record<string, LucideIcon> = {
  'icon-admin-arrow-down': ChevronDown,
  'icon-admin-arrow-up': ChevronUp,
  'icon-admin-dropdown': ChevronDown,
  'icon-admin-kebab': EllipsisVertical,
  'icon-admin-multiple-select': ListChecks,
  'icon-admin-open-answer': MessageSquare,
  'icon-admin-single-answer': CircleDot,
  'icon-admin-text-section': Type,
  'icon-arrow-down': CircleArrowDown,
  'icon-arrow-up': CircleArrowUp,
  'icon-Atom_-Icon-Archive': Archive,
  'icon-Atom_-Icon-Comment': MessageCircle,
  'icon-Atom_Icon-Add-subsection-copy': ListPlus,
  'icon-Atom_Icon-Alert': TriangleAlert,
  'icon-Atom_Icon-Arrow-left': ArrowLeft,
  'icon-Atom_Icon-Arrow-right': ArrowRight,
  'icon-Atom_Icon-Atom_Icon--User-Calling-copy': PhoneCall,
  'icon-Atom_Icon-birthday': Cake,
  'icon-Atom_Icon-Calendar': Calendar,
  'icon-Atom_Icon-Call-hang-up': PhoneOff,
  'icon-Atom_Icon-Call-out': PhoneOutgoing,
  'icon-Atom_Icon-Call-pause': Pause,
  'icon-Atom_Icon-Call-play': Play,
  'icon-Atom_Icon-Circular-back': Undo2,
  'icon-Atom_Icon-Circular-call-bar': Phone,
  'icon-Atom_Icon-Circular-done': CircleCheck,
  'icon-Atom_Icon-Circular-new-user-copy': UserPlus,
  'icon-Atom_Icon-Clock': Clock,
  'icon-Atom_Icon-Close': X,
  'icon-Atom_Icon-copy': Copy,
  'icon-Atom_Icon-Correct': Check,
  'icon-Atom_Icon-Disconnect': Unplug,
  'icon-Atom_Icon-Double-arrow': ChevronsUpDown,
  'icon-Atom_Icon-Down-small-Arrow': ChevronDown,
  'icon-Atom_Icon-Dropdown': ChevronDown,
  'icon-Atom_Icon-edit-list': SquarePen,
  'icon-Atom_Icon-edit-list-copy': SquarePen,
  'icon-Atom_Icon-Edit-script': FilePen,
  'icon-Atom_Icon-Eye': Eye,
  'icon-Atom_Icon-Filters': Filter,
  'icon-Atom_Icon-Forward': Forward,
  'icon-Atom_Icon-idea': Lightbulb,
  'icon-Atom_Icon-Idea': Lightbulb,
  'icon-Atom_Icon-Information': Info,
  'icon-Atom_Icon-Lamp': Lamp,
  'icon-Atom_Icon-lead': UserRound,
  'icon-Atom_Icon-Left-small-Arrow': ChevronLeft,
  'icon-Atom_Icon-List': List,
  'icon-Atom_Icon-Location': MapPin,
  'icon-Atom_Icon-Lock': Lock,
  'icon-Atom_Icon-Menu': Menu,
  'icon-Atom_Icon-Micro-mute': MicOff,
  'icon-Atom_Icon-Micro-on': Mic,
  'icon-Atom_Icon-multiple-select': ListChecks,
  'icon-Atom_Icon-On-Off': Power,
  'icon-Atom_Icon-Open-answer': MessageSquare,
  'icon-Atom_Icon-Play': Play,
  'icon-Atom_Icon-plus': Plus,
  'icon-Atom_Icon-Refresh': RefreshCw,
  'icon-Atom_Icon-Right-small-Arrow': ChevronRight,
  'icon-Atom_Icon-Search': Search,
  'icon-Atom_Icon-Single-answer': CircleDot,
  'icon-Atom_Icon-solution': Wrench,
  'icon-Atom_Icon-Text-section': Type,
  'icon-Atom_Icon-Trash': Trash2,
  'icon-Atom_Icon-Up-small-Arrow': ChevronUp,
  'icon-Atom_Icon-user': User,
  'icon-Atom_Icon-User-circle': CircleUser,
  'icon-Atom_Icon-User-fill': UserRound,
  'icon-Atom_Icon-Voicemail': Voicemail,
  'icon-Atom_Icon-Warning': TriangleAlert,
  'icon-Atom_Icon-Web': Globe,
  'icon-big-neutral': Meh,
  'icon-big-no-satisfied': Frown,
  'icon-big-satisfied': Smile,
  'icon-negative': Frown,
  'icon-neutral': Meh,
  'icon-positive': Smile,
  'icon-update': RefreshCw,
};

export default ICONS;
